<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item">
        <div class="md-layout md-alignment-center-left">
          <div class="md-layout-item md-size-100">
            <md-field md-clearable md-layout="box">
              <md-icon>search</md-icon>
              <label>Search Media Database</label>
              <md-input v-model="searchDatabase" />
            </md-field>
          </div>
        </div>
        <media-container media-title="Videos" :media-data="videoData" />
        <media-container media-title="Images" :media-data="imageData" />
      </div>
    </div>
  </div>
</template>

<script>
import MediaContainer from "./Media/MediaContainer.vue";
import ApiService from "@/services/api";

export default {
  components: {
    MediaContainer
  },
  data() {
    return {
      videoData: [],
      imageData: [],
      searchDatabase: null
    };
  },
  created() {
    ApiService.media
      .getAll()
      .then(response => {
        let media = response.data.data.media;

        this.imageData = media.filter(item => {
          return item.type === "image";
        });

        this.videoData = media.filter(item => {
          return item.type === "video";
        });
      })
      .catch(() => {
        this.$toast.error(
          "Could not fetch media. If this issue persists, please contact support."
        );
      });
  }
};
</script>

<style lang="scss" scoped></style>
